import moment from 'moment-timezone';

import { STORAGE_KEY } from './constants';

export const DEFAULT_TIMEZONE = 'Asia/Kolkata';

const getTimezoneOptionLabel = (timezoneName) => {
  const offset = moment.tz(timezoneName).format('Z');
  return `(UTC${offset}) ${timezoneName.replace(/_/g, ' ')}`;
};

export const TIMEZONE_OPTIONS = [
  DEFAULT_TIMEZONE,
  ...moment.tz.names()
    .filter((timezoneName) => timezoneName !== DEFAULT_TIMEZONE)
    .sort()
].map((timezoneName) => ({
  id: timezoneName,
  name: getTimezoneOptionLabel(timezoneName)
}));

export const isValidTimezone = (timezoneName) => Boolean(timezoneName && moment.tz.zone(timezoneName));

export const normalizeTimezone = (timezoneName) => (
  isValidTimezone(timezoneName) ? timezoneName : DEFAULT_TIMEZONE
);

export const getStoredUserTimezone = () => {
  try {
    const rawUser = localStorage.getItem(STORAGE_KEY.user);
    const user = rawUser ? JSON.parse(rawUser) : null;
    return normalizeTimezone(user?.timezone);
  } catch (error) {
    return DEFAULT_TIMEZONE;
  }
};

export const formatInTimezone = (value, format, timezoneName) => {
  if (!value) return null;
  const parsedValue = moment(value);
  if (!parsedValue.isValid()) return null;
  return parsedValue.tz(normalizeTimezone(timezoneName)).format(format);
};

export const parseInStoredTimezone = (value, format) => {
  if (!value) return null;
  const timezoneName = getStoredUserTimezone();
  if (moment.isMoment(value)) return value.clone();
  if (format && typeof value === 'string') {
    const localValue = moment.tz(value, format, true, timezoneName);
    if (localValue.isValid()) return localValue;
  }
  const parsedValue = moment(value);
  return parsedValue.isValid() ? parsedValue.tz(timezoneName) : null;
};

export const parseLocalDateTimeToUnix = (value, format, timezoneName) => {
  if (!value) return null;
  const parsedValue = moment.tz(value, format, true, normalizeTimezone(timezoneName));
  return parsedValue.isValid() ? parsedValue.unix() : null;
};

export const nowInTimezone = (timezoneName) => moment().tz(normalizeTimezone(timezoneName));
